/* Aurela Vida — comportamiento del tema.
   Sin dependencias y sin bloquear el render.
   1) Animaciones de entrada al hacer scroll.
   2) Caja de packs de la ficha de producto. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ */
  /* 1. Animaciones de entrada                                           */
  /* ------------------------------------------------------------------ */

  function reveal(root) {
    var items = (root || document).querySelectorAll('.au-reveal:not(.is-in)');
    if (!items.length) return;

    // Sin soporte o con movimiento reducido: se muestra todo de golpe.
    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Caja de packs                                                    */
  /* ------------------------------------------------------------------ */
  /* Las tarjetas no son el formulario: solo accionan el selector de
     variantes propio de Shopify, que sigue siendo la fuente de la verdad.
     Si esto fallara, el selector normal sigue debajo y la compra funciona. */

  function picker() {
    return document.querySelector('variant-selects');
  }

  function setOption(value) {
    var p = picker();
    if (!p) return false;

    var radio = p.querySelector('input[type="radio"][value="' + cssEscape(value) + '"]');
    if (radio) {
      if (radio.checked) return true;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var selects = p.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var opts = selects[i].options;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j].value === value) {
          if (selects[i].value === value) return true;
          selects[i].value = value;
          selects[i].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  // CSS.escape no existe en navegadores antiguos y aquí solo hace falta
  // escapar las comillas del selector de atributo.
  function cssEscape(v) {
    return String(v).replace(/"/g, '\\"');
  }

  function markSelected(card) {
    var box = card.closest('[data-au-packs]');
    if (!box) return;
    box.querySelectorAll('[data-au-pack]').forEach(function (el) {
      var on = el === card;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  // Vuelve a marcar la tarjeta correcta si el usuario usa el selector normal.
  function syncFromPicker() {
    var p = picker();
    if (!p) return;

    var current = [];
    p.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      current.push(r.value);
    });
    p.querySelectorAll('select').forEach(function (s) {
      current.push(s.value);
    });
    if (!current.length) return;

    document.querySelectorAll('[data-au-packs] [data-au-pack]').forEach(function (card) {
      var opts;
      try {
        opts = JSON.parse(card.dataset.options);
      } catch (e) {
        return;
      }
      var match = opts.every(function (v) {
        return current.indexOf(v) !== -1;
      });
      card.classList.toggle('is-on', match);
      card.setAttribute('aria-checked', match ? 'true' : 'false');
    });
  }

  // Delegación en document: sobrevive a que Shopify reemplace el bloque
  // al cambiar de variante.
  document.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('[data-au-pack]') : null;
    if (!card || card.disabled) return;

    var opts;
    try {
      opts = JSON.parse(card.dataset.options);
    } catch (err) {
      return;
    }

    markSelected(card);
    opts.forEach(setOption);
  });

  // Teclado: flechas dentro del grupo, como espera un radiogroup.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') {
      return;
    }
    var card = e.target.closest ? e.target.closest('[data-au-pack]') : null;
    if (!card) return;

    var box = card.closest('[data-au-packs]');
    if (!box) return;

    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-au-pack]:not([disabled])'));
    var i = cards.indexOf(card);
    if (i === -1) return;

    e.preventDefault();
    var next = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? i + 1 : i - 1;
    if (next < 0) next = cards.length - 1;
    if (next >= cards.length) next = 0;

    cards[next].focus();
    cards[next].click();
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) {
      // Shopify actualiza su estado en este mismo evento; leemos después.
      setTimeout(syncFromPicker, 0);
    }
  });

  /* ------------------------------------------------------------------ */

  /* Con la caja de packs, el selector nativo de Shopify sería un segundo
     selector para lo mismo: confuso, y más aún para nuestro público.
     Lo ocultamos SOLO desde JavaScript y solo si ambos existen. Si este
     script fallara, la clase nunca se pone y el selector nativo sigue
     visible: la ficha nunca se queda sin forma de elegir variante. */
  function toggleNativePicker() {
    var hasPacks = document.querySelector('[data-au-packs] [data-au-pack]');
    document.documentElement.classList.toggle('au-packs-on', !!(hasPacks && picker()));
  }

  /* ------------------------------------------------------------------ */
  /* 3. Héroe deslizante                                                 */
  /* ------------------------------------------------------------------ */

  function montarSlider(raiz) {
    if (raiz.dataset.auMontado === '1') return;
    raiz.dataset.auMontado = '1';

    var track = raiz.querySelector('[data-au-track]');
    var slides = Array.prototype.slice.call(raiz.querySelectorAll('[data-au-slide]'));
    if (!track || slides.length < 2) return;

    var dots = Array.prototype.slice.call(raiz.querySelectorAll('[data-au-dot]'));
    var btnPausa = raiz.querySelector('[data-au-pause]');
    var intervalo = parseInt(raiz.dataset.intervalo, 10) || 8000;

    // Con "reducir movimiento" activado no hay paso automático, nunca.
    var autoPermitido = raiz.dataset.autoavance === 'true' && !REDUCED;

    var actual = 0;
    var timer = null;
    var pausadoPorUsuario = false;

    function pintar() {
      track.style.transform = 'translateX(' + -actual * 100 + '%)';

      slides.forEach(function (s, i) {
        var on = i === actual;
        s.classList.toggle('is-on', on);
        if (on) {
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('aria-hidden', 'true');
        }
        // Una diapositiva oculta no debe poder recibir el foco con el tabulador:
        // marcarla aria-hidden y dejar sus enlaces tabulables es peor que no
        // ocultarla, porque el foco se va a un sitio que no se ve.
        s.querySelectorAll('[data-au-focusable]').forEach(function (el) {
          if (on) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });

      dots.forEach(function (d, i) {
        var on = i === actual;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function ir(i) {
      actual = (i + slides.length) % slides.length;
      pintar();
    }

    function siguiente() {
      ir(actual + 1);
    }
    function anterior() {
      ir(actual - 1);
    }

    function arrancar() {
      if (!autoPermitido || pausadoPorUsuario || timer) return;
      timer = setInterval(siguiente, intervalo);
      raiz.classList.remove('is-paused');
    }

    function parar(porUsuario) {
      if (porUsuario) pausadoPorUsuario = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (porUsuario) raiz.classList.add('is-paused');
    }

    // Reinicia la cuenta al interactuar: si acabas de pasar de diapositiva a
    // mano, no tiene sentido que salte sola medio segundo después.
    function reiniciar() {
      if (!autoPermitido || pausadoPorUsuario) return;
      parar(false);
      arrancar();
    }

    raiz.querySelector('[data-au-next]').addEventListener('click', function () {
      siguiente();
      reiniciar();
    });
    raiz.querySelector('[data-au-prev]').addEventListener('click', function () {
      anterior();
      reiniciar();
    });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        ir(parseInt(d.dataset.indice, 10) || 0);
        reiniciar();
      });
    });

    if (btnPausa) {
      btnPausa.addEventListener('click', function () {
        if (pausadoPorUsuario) {
          pausadoPorUsuario = false;
          btnPausa.setAttribute('aria-label', 'Pausar el paso automático');
          arrancar();
        } else {
          parar(true);
          btnPausa.setAttribute('aria-label', 'Reanudar el paso automático');
        }
      });
    }

    // Pausa al pasar el ratón y al entrar el foco con el teclado.
    raiz.addEventListener('mouseenter', function () {
      parar(false);
    });
    raiz.addEventListener('mouseleave', arrancar);
    raiz.addEventListener('focusin', function () {
      parar(false);
    });
    raiz.addEventListener('focusout', function (e) {
      if (!raiz.contains(e.relatedTarget)) arrancar();
    });

    // En una pestaña de fondo no hace falta gastar nada.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(false);
      else arrancar();
    });

    raiz.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        siguiente();
        reiniciar();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        anterior();
        reiniciar();
      }
    });

    // Arrastre con el dedo
    var x0 = null;
    raiz.addEventListener(
      'touchstart',
      function (e) {
        x0 = e.touches[0].clientX;
        parar(false);
      },
      { passive: true }
    );
    raiz.addEventListener(
      'touchend',
      function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) {
          if (dx < 0) siguiente();
          else anterior();
        }
        x0 = null;
        arrancar();
      },
      { passive: true }
    );

    pintar();
    arrancar();
  }

  function sliders(root) {
    (root || document).querySelectorAll('[data-au-slider]').forEach(montarSlider);
  }

  /* ------------------------------------------------------------------ */
  /* 4. Fachada del vídeo                                                */
  /* ------------------------------------------------------------------ */

  // Se muestra una imagen y el reproductor de YouTube o Vimeo solo se inserta
  // al pulsar. Así no se cargan cookies de terceros ni el peso del reproductor
  // a quien nunca va a darle al play.
  function videos(root) {
    (root || document).querySelectorAll('[data-au-video-play]').forEach(function (boton) {
      if (boton.dataset.auMontado === '1') return;
      boton.dataset.auMontado = '1';

      boton.addEventListener('click', function () {
        var marco = boton.closest('.au-video__marco');
        var plantilla = marco && marco.querySelector('[data-au-video-embed]');
        if (!plantilla) return;

        var iframe = plantilla.content.firstElementChild.cloneNode(true);
        boton.remove();
        plantilla.remove();
        marco.appendChild(iframe);
        // El foco pasa al reproductor: quien navega con teclado acaba de pedirlo.
        iframe.setAttribute('tabindex', '-1');
        iframe.focus({ preventScroll: true });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Vídeos que se reproducen solos                                   */
  /* ------------------------------------------------------------------ */

  // Van sin barra de controles, así que el botón de pausa es la única forma de
  // pararlos. Con "reducir movimiento" activado no arrancan.
  function videosSueltos(root) {
    (root || document).querySelectorAll('[data-au-vid]').forEach(function (caja) {
      if (caja.dataset.auMontado === '1') return;
      caja.dataset.auMontado = '1';

      var video = caja.querySelector('video');
      var boton = caja.querySelector('[data-au-vid-pausa]');
      if (!video || !boton) return;

      function marcar(pausado) {
        caja.classList.toggle('is-paused', pausado);
        boton.setAttribute('aria-label', pausado ? 'Reproducir el vídeo' : 'Pausar el vídeo');
      }

      if (REDUCED) {
        video.autoplay = false;
        video.pause();
        marcar(true);
      }

      boton.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          marcar(false);
        } else {
          video.pause();
          marcar(true);
        }
      });

      video.addEventListener('play', function () {
        marcar(false);
      });
      video.addEventListener('pause', function () {
        marcar(true);
      });

      // Fuera de pantalla no tiene sentido que siga corriendo
      if ('IntersectionObserver' in window && !REDUCED) {
        new IntersectionObserver(
          function (entradas) {
            entradas.forEach(function (e) {
              if (e.isIntersecting) {
                if (!caja.dataset.auPausadoAMano) video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.15 }
        ).observe(caja);

        boton.addEventListener('click', function () {
          if (video.paused) caja.dataset.auPausadoAMano = '1';
          else delete caja.dataset.auPausadoAMano;
        });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Galería de la ficha de producto                                  */
  /* ------------------------------------------------------------------ */

  // Foto grande + miniaturas. Al pulsar una miniatura se muestra su foto.
  // Sin deslizador: nada se mueve solo y nada hay que arrastrar.
  function galerias(root) {
    (root || document).querySelectorAll('[data-au-pgal]').forEach(function (gal) {
      if (gal.dataset.auMontado === '1') return;
      gal.dataset.auMontado = '1';

      var fotos = gal.querySelectorAll('[data-au-pgal-foto]');
      var minis = gal.querySelectorAll('[data-au-pgal-mini]');
      if (!fotos.length || !minis.length) return;

      function mostrar(indice) {
        fotos.forEach(function (f) {
          var on = f.dataset.auPgalFoto === indice;
          f.classList.toggle('is-on', on);
          if (on) f.removeAttribute('aria-hidden');
          else f.setAttribute('aria-hidden', 'true');

          // Un vídeo que deja de verse no debe seguir sonando ni gastando datos
          var v = f.querySelector('video');
          if (v && !on && !v.paused) v.pause();
        });

        minis.forEach(function (m) {
          var on = m.dataset.auPgalMini === indice;
          m.classList.toggle('is-on', on);
          if (on) m.setAttribute('aria-current', 'true');
          else m.removeAttribute('aria-current');
        });
      }

      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          mostrar(m.dataset.auPgalMini);
        });
      });

      // Flechas izquierda y derecha cuando el foco está en las miniaturas
      gal.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var activa = gal.querySelector('.au-pgal__mini.is-on');
        if (!activa || !gal.contains(document.activeElement)) return;
        var i = parseInt(activa.dataset.auPgalMini, 10);
        var siguiente = e.key === 'ArrowRight' ? i + 1 : i - 1;
        if (siguiente < 0) siguiente = minis.length - 1;
        if (siguiente >= minis.length) siguiente = 0;
        e.preventDefault();
        mostrar(String(siguiente));
        minis[siguiente].focus();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 7. Fecha de entrega estimada                                        */
  /* ------------------------------------------------------------------ */

  // Domingo de Pascua del año dado (algoritmo de Meeus/Jones/Butcher).
  // Se calcula en vez de dejar una tabla de fechas: Viernes Santo se mueve
  // cada año y una tabla caducaría sin que nadie se diera cuenta.
  function domingoPascua(anio) {
    var a = anio % 19;
    var b = Math.floor(anio / 100);
    var c = anio % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31);
    var dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(anio, mes - 1, dia);
  }

  var cacheFestivos = {};

  // Festivos NACIONALES de España. Los autonómicos y locales no se incluyen:
  // varían por provincia y no sabemos dónde vive quien mira la página. Eso hace
  // la estimación algo optimista en las comunidades con fiesta propia, y por eso
  // el rango va de minimo a maximo en vez de dar un solo día.
  function festivosDe(anio) {
    if (cacheFestivos[anio]) return cacheFestivos[anio];

    var fijos = [
      [0, 1], // Año Nuevo
      [0, 6], // Epifanía del Señor
      [4, 1], // Fiesta del Trabajo
      [7, 15], // Asunción de la Virgen
      [9, 12], // Fiesta Nacional de España
      [10, 1], // Todos los Santos
      [11, 6], // Día de la Constitución
      [11, 8], // Inmaculada Concepción
      [11, 25], // Navidad
    ];

    var lista = fijos.map(function (f) {
      return clave(new Date(anio, f[0], f[1]));
    });

    // Viernes Santo: dos días antes del Domingo de Pascua
    var pascua = domingoPascua(anio);
    var viernesSanto = new Date(pascua);
    viernesSanto.setDate(pascua.getDate() - 2);
    lista.push(clave(viernesSanto));

    cacheFestivos[anio] = lista;
    return lista;
  }

  function clave(fecha) {
    return fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate();
  }

  function esLaborable(fecha) {
    var dia = fecha.getDay();
    if (dia === 0 || dia === 6) return false; // domingo y sábado
    return festivosDe(fecha.getFullYear()).indexOf(clave(fecha)) === -1;
  }

  function sumarLaborables(desde, cuantos) {
    var fecha = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate());
    var contados = 0;
    var vueltas = 0;
    while (contados < cuantos) {
      fecha.setDate(fecha.getDate() + 1);
      if (esLaborable(fecha)) contados++;
      // Cinturón de seguridad: si algo va mal, se corta y se queda el texto
      // de reserva en vez de colgar el navegador.
      if (++vueltas > 400) throw new Error('demasiadas vueltas');
    }
    return fecha;
  }

  function nombre(fecha, tipo) {
    return new Intl.DateTimeFormat('es-ES', tipo)
      .format(fecha)
      .toLowerCase();
  }

  function frase(desde, hasta, prefijo) {
    var diaA = nombre(desde, { weekday: 'long' });
    var diaB = nombre(hasta, { weekday: 'long' });
    var mesA = nombre(desde, { month: 'long' });
    var mesB = nombre(hasta, { month: 'long' });

    // Si las dos fechas caen en el mismo mes, el mes se dice una sola vez.
    if (mesA === mesB) {
      return (
        prefijo + ' ' + diaA + ' ' + desde.getDate() + ' y el ' + diaB + ' ' + hasta.getDate() + ' de ' + mesB
      );
    }
    return (
      prefijo + ' ' + diaA + ' ' + desde.getDate() + ' de ' + mesA + ' y el ' + diaB + ' ' + hasta.getDate() + ' de ' + mesB
    );
  }

  function entregas(root) {
    (root || document).querySelectorAll('[data-au-entrega]').forEach(function (caja) {
      var salida = caja.querySelector('[data-au-entrega-texto]');
      if (!salida) return;

      try {
        var min = parseInt(caja.dataset.min, 10);
        var max = parseInt(caja.dataset.max, 10);
        if (!(min > 0) || !(max > 0) || max < min) return; // se queda la reserva

        var hoy = new Date();
        var texto = frase(
          sumarLaborables(hoy, min),
          sumarLaborables(hoy, max),
          caja.dataset.prefijo || 'Recíbelo entre el'
        );

        salida.textContent = texto;
        caja.classList.add('is-calculada');
        // Marca la fecha del cálculo: si la pestaña se queda abierta de un día
        // para otro, al volver se recalcula.
        caja.dataset.calculada = clave(hoy);
      } catch (e) {
        // Cualquier fallo deja el texto generico que ya venia del servidor.
      }
    });
  }

  // Si el visitante deja la pestaña abierta y vuelve al dia siguiente, las
  // fechas estarian caducadas. Al volver a la pestaña se comprueba.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    var hoy = clave(new Date());
    document.querySelectorAll('[data-au-entrega]').forEach(function (caja) {
      if (caja.dataset.calculada && caja.dataset.calculada !== hoy) entregas(caja.parentNode);
    });
  });

  /* ------------------------------------------------------------------ */
  /* 8. Antispam del formulario de contacto                              */
  /* ------------------------------------------------------------------ */

  /* Dos filtros invisibles, sin ningun desafio que resolver: el publico es
     mayor y un captcha visible sobra.

     1) Campo trampa: una persona no lo ve ni lo alcanza con el tabulador.
        Si viene relleno, quien lo relleno no era una persona.
     2) Tiempo minimo: nadie escribe nombre, correo y mensaje en menos de
        tres segundos desde que carga la pagina.

     LIMITE IMPORTANTE: esto vive en el navegador. Shopify procesa el
     formulario en su servidor y desde el tema no se puede validar alli. O
     sea que frena al bot que carga la pagina y rellena el formulario, que es
     el caso comun, pero no al que hace POST directo sin ejecutar nada. */

  var ESPERA_MINIMA = 3000;

  function antispam(root) {
    // Se buscan los formularios POR SU CAMPO TRAMPA, no por su acción. El
    // formulario de suscripción del pie también apunta a /contact, y ese sí
    // se rellena en menos de tres segundos con el correo autocompletado:
    // aplicarle la regla de tiempo seria tirar suscriptores de verdad.
    // Asi, solo se protege lo que se ha preparado a mano para ello.
    var trampas = (root || document).querySelectorAll('.au-trampa input');
    var formularios = [];
    trampas.forEach(function (t) {
      if (t.form && formularios.indexOf(t.form) === -1) formularios.push(t.form);
    });

    formularios.forEach(function (formulario) {
      if (formulario.dataset.auAntispam) return;
      formulario.dataset.auAntispam = '1';

      // El reloj arranca cuando el formulario queda listo, no cuando se
      // escribe la primera letra: lo que se mide es cuanto ha "vivido" la
      // pagina antes del envio.
      var nacido = Date.now();

      formulario.addEventListener('submit', function (evento) {
        var trampa = formulario.querySelector('.au-trampa input');
        var caidoEnLaTrampa = trampa && trampa.value.trim() !== '';
        var demasiadoRapido = Date.now() - nacido < ESPERA_MINIMA;

        if (!caidoEnLaTrampa && !demasiadoRapido) return;

        // Se descarta en silencio, tal cual: ni aviso ni mensaje de error.
        // A un bot no se le explica por que se le ha parado, porque es
        // justo lo que necesita para aprender a esquivarlo.
        evento.preventDefault();
        evento.stopPropagation();

        // El boton se queda desactivado tras un submit fallido en algunos
        // navegadores. Se devuelve a su sitio por si acaso.
        var boton = formulario.querySelector('[type="submit"]');
        if (boton) boton.disabled = false;
      });
    });
  }

  /* ------------------------------------------------------------------ */

  function init(root) {
    reveal(root);
    toggleNativePicker();
    syncFromPicker();
    sliders(root);
    videos(root);
    videosSueltos(root);
    galerias(root);
    entregas(root);
    antispam(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // El editor de temas recarga secciones sueltas sin recargar la página.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Se expone la calculadora de fechas para poder comprobarla desde fuera:
  // desde la consola del navegador y desde las pruebas automáticas. Sin esto
  // habría que duplicar el algoritmo en el test, y un algoritmo duplicado
  // acaba divergiendo del que se ejecuta de verdad.
  window.AurelaFecha = {
    pascua: domingoPascua,
    festivos: festivosDe,
    esLaborable: esLaborable,
    sumar: sumarLaborables,
    frase: frase,
  };
})();
